import * as e from "react";
const o = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M12.8 21.2V6.6L18 12l1.4-1.4-7.7-7.7L4 10.5l1.4 1.4 5.3-5.3v14.6h2z" }));
export {
  o as ReactComponent
};
